import { useSelector } from "react-redux"
import { IAuth } from "../../store/Auth"

/**
 * Portal of the signed-in business, using the same rule as App.tsx's
 * HomeRedirect: anything that is not an explicit SUPPLIER is a buyer.
 *
 * The dashboard was written for suppliers. Every place that says
 * "борлуулалт", picks a counterparty, or computes margin has to branch on
 * this — a buyer's own purchases are not sales, and a buyer owns no cost
 * data, so supplier-shaped numbers are not merely mislabelled for them,
 * they are wrong.
 */
export function useIsBuyer(): boolean {
  const user = useSelector((state: { auth: IAuth }) => state.auth.user)
  return user?.currentBusiness?.type !== "SUPPLIER"
}
